const originalGetContext = HTMLCanvasElement.prototype.getContext;

HTMLCanvasElement.prototype.getContext = function getContextWithReadbackHint(type, attributes) {
  if (type === '2d' && this.width <= 64 && this.height <= 64) {
    return originalGetContext.call(this, type, {
      ...attributes,
      willReadFrequently: true
    });
  }

  return originalGetContext.call(this, type, attributes);
};
